export default "__VITE_ASSET__Dzk1NflB__"